import { css, keyframes } from '@emotion/core'
import { btnInitializationStyle, CommonTxtBoxStyle, FloatingBottom, SafeAreaConstantPadding, SafeAreaEnvPadding, TxtLimit, } from '@styles/base.style'
import styled, { Theme, ThemeProps } from '@themes/theme'
import { liveScoreH } from './ChatLiveScore/index.style'
import { favoritePulseAni, favoriteTxtAni } from '@styles/match.style'

const sendBtnPCAni = keyframes`
  0% {
    height: 12px;
  }
  100% {
    height: 18px;
  }
`
const activityScoreGageAni = keyframes`
  0%{
    transform: rotate(0);
    animation-timing-function: ease-out;
  }
  30%, 100%{
    transform: rotate(360deg);
  }
`
const cheerForTeamEmoticonAni = keyframes`
  0%, 8% {
    transform: scale(1);
    transform-origin: bottom;
  }
  10%, 90% {
    transform: scale(2.2727);
    transform-origin: bottom;
  }
  100% {
    transform: scale(1);
    transform-origin: bottom;
  }
`

export const ChatToggleBtn = styled.button`
  z-index: 1;
  position: relative;
  width: 100%;
  height: 45px;
  border: none;
  background: none;
  .open-chat, .close-chat {
    position: absolute;
    top: 50%;
    left: 50%;
  }
  .open-chat {
    opacity: 1;
    display:flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    color: ${props => props.theme.color.modalBg};
    .chat-icon {
      position: absolute;
      top: 0;
      right: -5px;
      width: 62px;
      height: 62px;
    }
    .chat-light {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 45px;
      height: 45px;
    }
    .chat-bubble {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 22px;
      height: auto;
    }
    .favorite-pulse {
      display: none;
      opacity: 0;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 45px;
      height: 45px;
      border-radius: 50%;
      &.pulse-2 {
        width: 42px;
        height: 42px;
      }
    }

  }
  .close-chat {
    opacity: 0;
    color: ${props => props.theme.color.btn};
    transform: translate(-50%, -50%);
    .x-ico {
      display:block;
      width: 14px;
      height: 14px;
      transform: rotate(45deg);
      &::before, &::after {
        content:'';
        display: block;
        position:absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 2px;
        height: 19px;
        background: ${props => props.theme.color.modalTxt};
        border-radius: 10px;
      }
      &::after {
        width: 19px;
        height: 2px;
      }
    }
  }
  &.open {
    position:absolute;
    right: 18px;
    bottom: max(calc(env(safe-area-inset-bottom) + 75px), 90px);
    width: 42px;
    height: 42px;
    box-shadow: none;
    background: ${props => props.theme.color.disableTxt};
    border-radius: 50%;
    opacity: .35;
    .x-ico {
      &::before, &::after {
        background: ${props => props.theme.color.themeTxt};
      }
    }
    .open-chat {
      opacity: 0;
    }
    .close-chat {
      opacity: 1;
    }
  }
`

export const TestStyle = css`
  width: 100%;
  height: auto;
  max-height: 500px;
  overflow:auto;
  background: white;
  line-height: 2rem;
  * {
    color: black;
  }
`

export const ProfileImgWrapStyle = (props: ThemeProps) => css`
  position:relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background: ${props.theme.color.modalgray};
  .profile-img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    height: auto;
    &.custom-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`

export const ChatWrap = styled.div`
  position: fixed;
  bottom: 90px; /* ${FloatingBottom}를 인식하지 못하고 있어서 작성함 / 인식못하는 이유 찾아야함*/
  bottom: ${FloatingBottom};
  right: 18px;
  padding-bottom: ${SafeAreaEnvPadding};
  padding-bottom: ${SafeAreaConstantPadding};
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  width: 45px;
  min-height: 45px;
  height: auto;
  .modal-bg {
    display: block;
  }
  &.open-chat-wrap {
    bottom: 0;
    right: 0;
    width: 100%;
    height: calc(100% - ${liveScoreH}px);
    .modal-bg {
      display: block;
    }
  }
  .chat-list {
    position: relative;
    display: flex;
    flex-flow: column;
    justify-content: flex-end;
    width: 100%;
    height: auto;
    min-height: 100%;
    padding-top: 10px;
    color: ${props => props.theme.color.btn};
    background: ${props => props.theme.color.modalBg};

    &--item {
      display: flex;
      flex-wrap: nowrap;
      width: 100%;
      height: auto;
      min-height: 40px;
      margin-bottom: 10px;
      padding: 0 14px;
      // 프로필 사진
      .user-profile-btn {
        display:flex;
        flex-flow: column;
        justify-content: flex-start;
        z-index: 0;
        width: 42px;
        height: 48px;
        margin-right: 8px;
        background: none;
        .profile-img-wrap {
          ${ProfileImgWrapStyle};
        }
        svg {
          position:absolute;
          bottom: 0;
          right: 0;
          width: 20px;
          path {
            &.fill {
              fill: ${props => props.theme.color.modalSubBg};
            }
            &.line {
              fill: ${props => props.theme.color.modalBg};
            }
          }
        }

        &.active {
          svg path {
            &.fill {
              fill: ${props => props.theme.color.modalyellow};
            }
          }
        }
      }
      
      // 채팅_프로필 우측 응원 컨텐츠
      .chat-contents {
        display: flex;
        flex-flow: column;
        align-items: flex-start;
        flex: 1;
        .nick-info {
          margin-bottom: 5px;
          line-height: 1.8rem;
          .nick-name {
            color: ${props => props.theme.color.modalTxt};
          }
          .cheer-for-team-info {
            display: inline-block;
            margin-left: 5px;
            position: relative;
            background: transparent;
            &::after {
              content: '';
              display: block;
              position: absolute;
              top: 14px;
              width: 100%;
              height: 1px;
              background: ${props => props.theme.color.matchTit1};
            }
            .team-info {
              color: ${props => props.theme.color.matchTit1};
              font-size: ${props => props.theme.font.small};
              .home-team-emblem, .away-team-emblem {
                display: inline-block;
                width: 12px;
                height: 12px;
                margin: 0 2px;
                transform: translateY(-1px);
                .team-emblem {
                  width: 100%;
                  height: auto;
                }
              }
              .home-team-name, .away-team-name, .home-team-score, .away-team-score {
                color: ${props => props.theme.color.matchTit1};
                font-size: ${props => props.theme.font.small};
                &.win {
                  color: ${props => props.theme.color.modalred};
                }
              }
            }
            .match-status {
              > span {
                color: ${props => props.theme.color.matchTit1};
                font-size: ${props => props.theme.font.small};
              }
            }
          }
          .reply-nick-name {
            color: ${props => props.theme.color.modalgray};
            &--img {
              width: 16px;
              transform: translateY(-1px);
            }
          }
        }
        .chat-bubble {
          display: flex;
          flex-flow: column;
          align-items: flex-start;
          flex-wrap: wrap;
          width: auto;
          max-width: min(calc(100vw - 130px), 400px);
          height: auto;
          padding: 7px 10px;
          background: ${props => props.theme.color.modalSubBg2};
          border-radius: 0 10px 10px 10px;
          position: relative;
          .preview-box-wrap {
            width: 100%;
            max-width: initial;
            min-width: initial;
          }
          &.pc {
            .social-media { // sns링크보기 스타일 변경(실시간채팅창)
              width: 100%;
            }
            .preview-box { // sns링크보기 스타일과 동일하게 작성
              .cheer-for-team-contents-wrap {
                max-width: 149px;
              }
            }
            .cheer-for-team-emotion {
              display: none;
            }
          }
          // sns링크보기 스타일 변경(실시간채팅창)
          &.social-media {
            width: auto;
            .rsme-instagram-embed {
              max-width: calc(100vw - 88px);
              overflow: hidden;
            }
          }
          &.s-user {
            background: linear-gradient(136deg, #BCE19C, #9FDF9D) !important;
            box-shadow: inset 1px 1px 1px #FAFFF650, 1px 1px 1px #08290B10;
          }
          &.hard-user {
            background: #F2EBC9 !important;
          }
          &.premium-user {
            background: #EFCABF !important;
          }
          &.s-user, &.hard-user, &.premium-user {
            .cheer-for-team-contents-wrap {
              background: #EEEEEE99 !important; //my-message보다 우선 적용되도록 작성하였습니다.
            }
          }
          &.is-cheer-for-team {
            margin-bottom: 17px;
            .chat-bubble--upload, .betting-list {
              margin-top: 3px;
            }
          }
          &.is-betting-history {
            width: 100%;
          }
          &--upload {
            width: auto;
            height: auto;
            margin-bottom: 3px;
            overflow: hidden;
            button {
              z-index: 0;
              border-radius: 0;
              background: none;
            }
            &--img {
              width: auto;
              max-width: 100%;
              height: 70px;
              max-height: 70px;
            }
            // 실시간 채팅창 응원글 클릭버튼(타임라인팝업 출력) 
            &--cheer-for-team-btn {
              border-radius: 0;
              width: 100%;
              margin-bottom: 3px;
              .preview-box {
                width: 100%;
                .cheer-for-team-contents-wrap {
                  background: #EEEEEE66;
                }
              }
              &.is-not-match-record {
                cursor: default;
              }
            }
          }
          // 실시간 채팅창 응원글 추가버튼
          &--cheer-for-team-btn {
            position: absolute;
            right: 4px;
            bottom: -17px;
            width: auto;
            height: 14px;
            border-radius: 0;
            .cheer-btn-img {
              width: auto;
              height: 100%;
            }
          }
          &--txt {
            ${CommonTxtBoxStyle};
            line-height: 1.8rem;
            width: 100%;
            text-align: left;
            &, * {
              color: ${props => props.theme.color.modalTxt};
              font-weight: ${props => props.theme.fontW.medium};
            }
            .link {
              color: ${props => props.theme.color.blue};
            }
          }
          .small {
            &, * {
              font-size: 1.2rem !important;
            }
          }
          .large {
            &, * {
              font-size: 1.5rem !important;
            }
          }
        } /* chat-bubble */
      }
      // 내가 보낸 메시지
      &.my-message {
        .chat-contents {
          .chat-bubble {
            background: ${props => props.theme.color.themeTxt};
            .preview-box {
              .cheer-for-team-contents-wrap {
                background: #D5D5D599;
              }
            }
          }
        }
      }
      // PC버전 오늘의 승부사 메시지
      &.pc-pick-message {
        padding: 0 6px;
      }
    }
  }

  // 채팅 하단
  .chat-input-area {
    z-index: 1;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-wrap: wrap;
    position:relative;
    width: 100%;
    height: auto;
    padding: 8px 0 0;
    background: ${props => props.theme.color.modalBg};
    border-top: 1px solid ${props => props.theme.color.modalSubBg};
    &.close {
      display: none;
    }
    .select-btn {
      display: inline-flex;
      justify-content: flex-start;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 48px;
      height: 67px;
      border-radius: 0;
      padding: 0 10px 14px 14px;
      background: ${props => props.theme.color.TP};
      .plus-ico {
        position: relative;
        display: block;
        width: 24px;
        height: 24px;
        border-radius: 5px;
        border: 2px solid ${props => props.theme.color.gray};
        transition: all .3s;
        &::before, &::after {
          content:'';
          display: block;
          position:absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 2px;
          height: 13px;
          border-radius: 30px;
          background: ${props => props.theme.color.gray};
          transition: all .3s;
        }
        &::after {
          width: 13px;
          height: 2px;
        }
      }

      &.active {
        .plus-ico {
          border: none;
          background: ${props => props.theme.color.disableTxt};
          &::before, &::after  {
            transform: translate(-50%, -50%) rotate(45deg);
            background: ${props => props.theme.color.modalBg};
          }
        }
      }
    }
    .pick-wrap {
      z-index: 1; // 응원글패널 열린 상태에서의 스타일을 위해 수정
      opacity: 0;
      position: absolute;
      bottom: 60%;
      left: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: calc(100% - 28px);
      height: 40px;
      margin: 0 14px;
      box-shadow: 0 4px 6px rgba(0,0,0,.2);
      border-radius: 10px;
      transition: none;
      overflow: hidden;
      &::before {
        content:'';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: inherit;
        background: ${props => props.theme.color.disableTxt};
      }
      &::after {
        content:'';
        display: block;
        position:absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 1px;
        height: 16px;
        border-right: 1px solid ${props => props.theme.color.modalDarkBg};
      }
      &.open {
        z-index: 2; // 응원글패널 열린 상태에서의 스타일을 위해 수정 
        opacity: 1;
        bottom: 120%;
        transition: all .3s cubic-bezier(.06,.56,.47,.83);
      }
      // 이모티콘창이 열려 있을 때
      &.emoticon-open {
        bottom: 90%;
        &.open {
          bottom: 105%;
        }
      }
    } /* pick-wrap */
    .bet-share-btn, .upload-img-wrap {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: inherit;
      svg, img {
        margin-right: 8px;
        transform: translateY(-5%);
      }
      svg {
        width: 21px;
      }
      img {
        width: 25px;
      }
    }
    .bet-share-btn {
      background: none;
      &.hide {
        display: none;
      }
      &.visible {
        display: block;
      }
    }
    .upload-img-wrap {
      position: relative;
      overflow:hidden;
      &--input {
        opacity: 0;
        position:absolute;
        top: 0; // [이슈링크] (https://task.zempublic.co.kr/view.php?id=9673)
        left: 0;
        width: inherit;
        line-height: 999;
        text-indent: 999px;
        overflow: hidden;
        color: transparent;
      }
    }
    // 업로드할 이미지 미리보기
    .img-preview {
      position: absolute;
      bottom: 100%;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding: 20px 0;
      backdrop-filter: blur(6px);
      background: #00000080;
      flex-wrap: wrap;
      // 업로드_베팅내역(MO 스타일만 지정)
      .betting-list {
        width: calc(100% - 140px);
        .betting-list-bg {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      // 업로드_응원글
      .cheer-for-team-btn {
        width: 100%;
        height: 20px;
        margin-bottom: 15px;
        border-radius: 0;
        z-index: 0;
        background: none;
        color: ${props => props.theme.color.modalSubBg2};
        font-size: ${props => props.theme.font.large};
        font-weight: ${props => props.theme.fontW.medium};
      }
      .preview-wrap {
        position: relative;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        :nth-of-type(even) { // 채팅응원글과 동시에 첨부되는 컨텐츠가 있을 시 (미리보기 2개 출력될 시) 구분선 스타일 (MO)
          &.existing {
            ::before {
              content: '';
              display: block;
              width: 100%;
              height: 1px;
              background: ${props => props.theme.color.modalTxt};
              opacity: .2;
              margin: 10px 18px;
            }            
          }
        }
        .available-time {
          margin-top: 10px;
          width: 100%;
          text-align: center;
          color: ${props => props.theme.color.gray};
          font-size: ${props => props.theme.font.small};
          svg {
            width: 10px;
            height: auto;
            fill: ${props => props.theme.color.gray};
            margin-right: 3px;
            transform: translateY(1.5px);
          }
          &-num {
            margin-left: 4px;
            color: ${props => props.theme.color.themeTxt};
            font-size: ${props => props.theme.font.small};
          }
        }
        .preview-box-wrap {
          max-width: initial;
        }
      }
      .upload-img-preview {
        width: auto;
        max-width: calc(100% - 60px);
        height: auto;
        max-height: 70px;
      }
      .delete-img-btn {
        position: absolute;
        top: 50%;
        right: 4px;
        transform: translateY(-50%);
        width: 42px;
        height: 42px;
        background: none;
        .x-ico {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(45deg);
          &::before, &::after {
            content:'';
            display: block;
            position:absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 2px;
            height: 18px;
            border-radius: 10px;
            background: ${props => props.theme.color.modalBg};
          }
          &::after {
            width: 18px;
            height: 2px;
          }
        }
      }
    }
    .chat-input {
      position:relative;
      display: inline-flex;
      flex-flow: column;
      flex: 1;
      margin-bottom: 21px;
      margin-left: 48px;
      //width: calc(100% - 78px);
      z-index: 2; //pick-wrap의 z-index 조절에 따라 추가한 스타일입니다.
      &--reply {
        display:flex;
        align-items: center;
        padding: 0 5px 5px;
        color: ${props => props.theme.color.modalgray};
        font-weight: ${props => props.theme.fontW.medium};
        &--cancel-btn {
          display:flex;
          justify-content: center;
          align-items: center;
          width: 20px;
          height: inherit;
          margin-left: -3px;
          background: none;
          .cancel-ico {
            position:relative;
            display: inline-block;
            width: 10px;
            height: 10px;
            background: ${props => props.theme.color.modalgray};
            border-radius: 50%;
            transform: rotate(45deg);
            &::before, &::after {
              content:'';
              display: block;
              position:absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 5px;
              height: 1px;
              background: ${props => props.theme.color.themeTxt};
            }
            &::after {
              width: 1px;
              height: 5px;
            }
          }
        }
      }
      &--textarea {
        padding: 8px 30px 8px 8px;
        line-height: 2rem;
        font-weight: ${props => props.theme.fontW.medium};
        background: ${props => props.theme.color.themeTxt} !important;
        border-color: ${props => props.theme.color.modalSubBg};
        border-radius: 18px;
        resize: none;
        -webkit-user-select: auto;
        -webkit-touch-callout: default;
        &.ant-input:hover, &.ant-input:focus, &.ant-input:active {
          border-bottom: 1px solid ${props => props.theme.color.modalSubBg} !important;
        }
        &::placeholder {
          color: #c9c9c9 !important;
          opacity: 1; /* Firefox */
        }
        &.error {
          color: orangered;
        }
      }
      .emoticon-btn {
        position: absolute;
        bottom: 7px;
        right: 5px;
        width: 24px;
        height: 24px;
        background: none;
        svg {
          width: 24px;
          .line {
            fill: ${props => props.theme.color.gray};
          }
        }
        &.active {
          svg {
            .line {
              fill: ${props => props.theme.color.btn};
            }
          }
        }
      }
    }
    .send-btn {
      width: 34px;
      height: 34px;
      margin-left: 10px;
      margin-right: 14px;
      margin-bottom: 21px;
      background: none;
      transform: translateY(-1px);
      transition: all .3s;
      cursor: initial;
      .send-ico {
        position:relative;
        display: block;
        width: inherit;
        height: inherit;
        border-radius: 50%;
        &--arrow {
          position:absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 2px;
          height: 13px;
          border-radius: 1px;
          &::before, &::after {
            content:'';
            display: block;
            position:absolute;
            top: 0;
            left: -3px;
            width: 2px;
            height: 7px;
            transform: rotate(45deg);
            border-radius: 1px;
          }
          &::after {
            left: 3px;
            transform: rotate(-45deg);
          }
        }
      }
      &.active {
        cursor: pointer;
        .send-ico {
          border: none;
          background: ${props => props.theme.color.secondaryBg};
          opacity: 1;
          transition: all .3s;
          &--arrow {
            transition: transform .3s;
            background: ${props => props.theme.color.modalBg};
            &::before, &::after {
              background: ${props => props.theme.color.modalBg};
            }
          }
          &:hover {
            opacity: .88;
            .send-ico--arrow {
              animation: ${sendBtnPCAni} .3s forwards 1;
              background: ${props => props.theme.color.themeTxt};
              &::before, &::after {
                background: ${props => props.theme.color.themeTxt};
              }
            }
          }
        }
      }
    } /* send-btn */
    ::before { // 응원글 패널과 이모티콘 패널 동시에 열었을 때 채팅입력란 배경이 사라져 배경 별도 삽입하였습니다.
      content: '';
      display: block;
      width: 100%;
      height: 55px;
      background: ${props => props.theme.color.modalBg};
      POSITION: absolute;
      top: 0;
    }
  } /* chat-input-area */
  &.pc-chat {
    position: relative;
    bottom: initial;
    right: initial;
    width: 255px;
    //height: auto;
    height: 548px;
    margin-top: 10px;
    border-radius: 0;
    .am-tabs-content-wrap {
      max-height: 396px;
      //min-height: 396px;
    }
    .chat-list--item .chat-contents .chat-bubble {
      max-width: initial;
    }
    .img-preview {
      position: absolute;
      bottom: 100%;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding: 15px 0;
      background: #00000080;
      backdrop-filter: blur(6px);
      flex-wrap: wrap;
      .preview-wrap {
        width: 100%;
        display: flex;
        position: relative;
        flex-wrap: wrap;
        justify-content: center;
        :nth-of-type(even) { // 채팅응원글과 동시에 첨부되는 컨텐츠가 있을 시 (미리보기 2개 출력될 시) 구분선 스타일 (PC)
          &.existing {
            ::before {
              content: '';
              display: block;
              width: 100%;
              height: 1px;
              background: ${props => props.theme.color.modalTxt};
              opacity: .2;
              margin: 10px 18px;
            }
          }
        }
        .available-time {
          margin-top: 9px;
          width: 100%;
          text-align: center;
          color: ${props => props.theme.color.gray};
          font-size: ${props => props.theme.font.small};
          svg {
            width: 10px;
            height: auto;
            fill: ${props => props.theme.color.gray};
            margin-right: 3px;
            transform: translateY(1.5px);
          }
          &-num {
            margin-left: 4px;
            color: ${props => props.theme.color.themeTxt};
            font-size: ${props => props.theme.font.small};
          }
        }
        .upload-img-preview {
          width: auto;
          height: 70px;
        }
        // pc 실시간채팅창 미리보기 스타일 - 베팅내역
        .pc-betting-list {
          width: 180px;
          transform: translateX(-20px);
        }
        // pc 실시간채팅창 미리보기 스타일 - 응원글
        .preview-box-wrap {
          max-width: 180px;
          min-width: 180px;
          transform: translateX(-20px);
        }
        .delete-img-btn {
          position: absolute;
          top: 50%;
          right: 8px;
          width: 42px;
          height: 42px;
          background: none;
          transform: translateY(-50%) rotate(45deg);
          .x-ico {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            &::before, &::after {
              content:'';
              display: block;
              position:absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 2px;
              height: 18px;
              border-radius: 10px;
              background: ${props => props.theme.color.modalBg};
            }
            &::after {
              width: 18px;
              height: 2px;
            }
          }
        }
        // 응원글 미리보기 이모티콘 PC에서 보이지 않도록하기 위해 작성
        .cheer-for-team-emotion {
          display: none;
        }
      }
    }
    .emoticon-area {
      display: block;
      height: 0;
      position: relative;
      z-index: 3; // 채팅응원글 패널보다 preview가 상단에 위치해야하기 때문에 작성
      .emoticon-list {
        display: none;
      }
      &.show {
        height: auto;
        margin-top: 0;
        .emoticon-list {
          display: flex;
        }
      }
      .emoticon-list {
        &--item {
          width: 25%;
          padding: 2%;
        }
      }
    }
    .chat-input-area {
      z-index: 1; // 채팅응원글 패널이 최상단에 위치해야하기때문에 작성
      flex-flow: column;
      justify-content: center;
      align-items: center;
      .chat-input {
        width: calc(100% - 28px);
        margin-bottom: 14px;
        margin-left: 0;
      }
      .chat-btn-list {
        display: flex;
        width: 100%;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 14px;
        padding: 0 14px;
        .bet-share-btn,.upload-img-wrap, .emoticon-btn  {
          flex: initial;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-right: 16px;
          background: ${props => props.theme.color.modalgray};
          transition: all .15s;
          &:hover {
            background: ${props => props.theme.color.modalDarkBg};
          }
          svg, img {
            margin-right: 0;
          }
        }
        .emoticon-btn.active {
          background: ${props => props.theme.color.btn};
        }
        .bet-share-btn {
          svg {
            width: 18px;
          }
        }
        .upload-img-wrap {
          position: relative;
          overflow:hidden;
          img {
            width: 22px;
          }
          &--input {
            position:absolute;
            left: 0;
            width: inherit;
            line-height: 999;
            text-indent: 999px;
            overflow: hidden;
            color: transparent;
          }
        }
        .emoticon-btn {
          svg {
            width: 20px;
            .line {
              fill: ${props => props.theme.color.themeTxt};
            }
          }
        }
        .send-btn {
          margin: 0;
          transform: translate(55px, -1px);
        }
      } /* chat-btn-list */
    }
  } /* pc-chat */
  /* 채팅 플로팅 버튼(프리미엄 분석가, 오늘의 승부사, 활동스코어) */ 
  .chat-floating-btn {
    width: 42px;
    position: absolute;
    top: 56px;
    right: 18px;
    &-list {
      :not(:last-child) {
        margin-bottom: 12px;
      }
      &.today-pick {
        position: relative;
        .btn-badge {
          top: 0;
          right: -2px;
        }
      }
      // 활동스코어 플로팅 버튼
      &.activity-score {
        position: relative;
        .new-badge-ico {
          position: absolute;
          top: 0;
          right: -2px;
          width: 16px;
          height: 16px;
          z-index: 1;
        }
        .progress-bar-wrap {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin-top: 1px;
          .progress-bar {
            transform: rotate(-90deg);
            .bg {
              stroke: #3F4953;
              stroke-width: 2px;
            }
            .processing {
              stroke: ${props => props.theme.color.modalOrange};
              stroke-width: 2px;
              stroke-linecap: round;
            }
          }
          &.acheive {
            .progress-bar {
              transform: rotate(0);
              animation: ${activityScoreGageAni} 2s .5s infinite;
              .bg {
                stroke: transparent;
              }
              .processing {
                stroke-width: 2px;
                stroke: url(#progress-linear-gradient);
              }
            }
          }
        }
        .activity-score-btn {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 38px;
          height: 38px;
          border-radius: 50%;
          background: ${props => props.theme.color.accordion1};
          .activity-score-btn-img {
            width: 34px;
            height: auto;
            margin-top: 2px;
          }
        }
        .activity-popup-wrap {
          z-index: 2;
          max-width: 235px;
          height: auto;
          position: absolute;
          top: 0;
          right: 0;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
    &.is-popular-searches {
      top: calc(56px + 49px);
    }
  }/* 채팅 플로팅 버튼(프리미엄 분석가, 오늘의 승부사, 활동스코어) */
`
export const CheerForTeamListBtnStyle = (theme: Theme) => css`
  position: relative;
  width: 100%;
  height: 63px;
  margin-bottom: 6px;
  background: ${theme.color.modalBg};
  border-radius: 12px;
  transition: all 0.3s;
  line-height: 2rem;
  box-shadow: 3px 3px 6px #00000005;
  overflow: hidden;
  display: flex;
  align-items: center;
  &::before {
    display: none;
  }
  .ant-list-item {
    flex-wrap: nowrap;
    justify-content: space-between;
    padding: 0 22px 0 0;
  }
  // 찜버튼
  .favorite-btn {
    position: absolute;
    left: 0;
    width: 158px;
    height: 100%;
    z-index: 1;
    background: none;
    border-radius: 0;
    &.pc {
      width: 118px;
    }
    .favorite-btn-ele {
      overflow: visible;
      position: absolute;
      left: 26px;
      top: 50%;
      transform: translateY(-50%);
      .favorite-pulse {
        opacity: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        &.pulse-2 {
          width: 6px;
          height: 6px;
        }
      }
      .favorite-btn-img{
        width: 16px;
        height: auto;
        opacity: 1;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .favorite-btn-active-img{
        width: 18px;
        height: 18px;
        opacity: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    &.active {
      .favorite-btn-img{
        opacity: 0;
      }
      .favorite-btn-active-img{
        opacity: 1;
      }
      &.ani {
        .favorite-btn-active-img{
          animation: ${favoriteTxtAni} .4s 1 forwards cubic-bezier(.43,-0.78,0,1.66);
        }
        .favorite-pulse {
          opacity: 1;
          animation: ${favoritePulseAni} .65s 1 ease-out;
          &.pulse-2 {
            animation-delay: .1s;
          }
        }
      }
    }
  }// 찜버튼
  .sports-ico {
    position: absolute;
    right: -13px;
    top: 15px;
    width: 70px;
    height: 70px;
    opacity: .04;
  }
  .date-info-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    width: 106px;
    min-width: 106px;
    margin-left: 52px;
    ::after {
      content: '';
      display: block;
      position: absolute;
      right: 0;
      width: 1px;
      height: 34px;
      background: ${theme.color.modalSubBg};
      box-shadow: 1px 0 0 #EEEEEE40;
    }
    .match-status {
      &.pc {
        .time-icon {
          display: none;
        }
      }
    }
    .date-info {
      .date, .time {
        font-size: ${theme.font.medium};
        font-weight: ${theme.fontW.medium};
        color: ${theme.color.modalTxt};
      }
      .time {
        margin-left: 2px;
      }
    }
  }
  .match-info-wrap {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    width: 100%;
    max-width: calc(100% - 144px);
    margin-top: 1px;
    .team-info {
      width: 100%;
      height: 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: ${theme.color.modalTxt};
      .team-emblem {
        width: 16px;
        height: 16px;
        margin: 1px 4px 0 11px;
        &-img {
          width: auto;
          height: 100%;
        }
      }
      .home-team-name, .away-team-name {
        color: ${theme.color.disableBg};
        margin-right: auto;
        width: calc(100% - 70px);
        text-align: left;
      }
      .home-team-score, .away-team-score {
        color: ${theme.color.modalTxt};
        position: absolute;
        right: 22px;
        &.win {
          color: ${theme.color.modalred};
        }
        .before-score {
          color: ${theme.color.modalgray}; 
        }
        .match-state {
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          top: -3px;
          right: 0; 
          width: auto;
          height: 3px;
          opacity: .35;
          .circle {
            display: block;
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background: ${theme.color.modalTxt};
            margin-left: 2px;
          }
        }
      }
    }
  }
  &.pc {
    height: 57px;
    .date-info-wrap {
      width: 60px;
      min-width: 60px;
      margin-left: 40px;
      line-height: 12px;
      .date-info {
        .time {
          display: block;
          width: 100%;
          text-align: left;
        }
      }
    }
    .match-info-wrap {
      width: 128px;
      max-width: 100%;
      margin-top: 8px;
      .team-emblem {
        margin: -2px 4px 0 6px;
      }
      .home-team-name, .away-team-name {
        width: calc(100% - 60px);
      }
      .home-team-score, .away-team-score {
        right: 12px;
      }
    }
  }
`
export const CheerForTeamEmoticonListStyle= (theme: Theme) =>  css`
  width: 211px;
  height: 36px;
  border-radius: 31px;
  background: #14141466;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  box-shadow: 0 3px 6px #00000029;
  .cheer-for-team-emoticon-list {
    .ant-radio-button-wrapper {
      border: none !important;
      border-radius: 0 !important;
    }
    // 클릭 시
    .ant-radio-button-wrapper-checked {
      z-index: 0;
      border: none;
      background: ${theme.color.underover};
      box-shadow: none;
      outline: none;
      &::before {
        display: none;
      }
      .radio-button-rate, .radio-button-outcome-name {
        color: ${theme.color.subBg};
      }
    }
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
      color: ${theme.color.TP};
      border: none;
    }
    .ant-radio-button-wrapper:not(:first-of-type)::before {
      background: none;
    }
    &--item {
      margin: 0 3px;
      padding: 5px 4px 3px 4px;
      height: 26px;
      border-radius: 14px;
      border: none;
      background: none;
      :first-of-type {
       margin-left: 11px; 
      }
      :last-of-type {
        margin-right: 11px;
      }
      &.ant-radio-button-wrapper-checked {
        background: #ffffff33;
        box-shadow: none;
        display: flex;
        align-items: flex-start;
      }
      ::before {
        display: none !important;
      }
      :not(:first-child)::before {
        display: none !important;
      }
      > span:last-of-type {
        display: flex;
        height: 18px;
        .cheer-for-team-emoticon-img {
          width: auto;
          height: 18px;
        }
      }
    }
  }
`
export const SimpleCheerForTeamHistoryStyle = (theme: Theme) => css`
  display: flex;
  flex-wrap: wrap;
  background: ${theme.color.TP};
  width: calc(100% - 140px);
  max-width: 230px;
  min-width: 195px;
  .match-status-name {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: right;
    .time-icon {
      width: 10px;
      margin-right: -14px;
      z-index: 1;
      .fill {
        fill: ${theme.color.mainBg};
      }
    }
    &-txt {
      height: 15px;
      line-height: 17px;
      border-radius: 4px 4px 0 0;
      font-size: ${theme.font.small};
      font-weight: ${theme.fontW.medium};
      padding: 0 5px 0 16px;
    }
    &.live {
      .time-icon {
        .fill {
          fill: ${theme.color.themeTxt};
        }
      }
      .match-status-name-txt {
        background: ${theme.color.modalred};
        color: ${theme.color.themeTxt};
      }
    }
    &.not-started {
      .time-icon {
        .fill {
          fill: ${theme.color.themeTxt};
        }
      }
      .match-status-name-txt {
        background: ${theme.color.tabBg};
        color: ${theme.color.themeTxt};
      }
    }
    &.closed {
      .time-icon {
        .fill {
          fill: ${theme.color.modalBg};
        }
      }
      .match-status-name-txt {
        background: ${theme.color.gray};
        color: ${theme.color.modalBg};
      }
    }
  }
  .preview-box {
    display: flex;
    width: 100%;
    background: ${theme.color.TP};
  }
  .cheer-for-team-emotion {
    width: 44px;
    height: 44px;
    display: block;
    ${btnInitializationStyle};
    > img {
      width: auto;
      height: 100%;
    }
    &.active {
      animation: ${cheerForTeamEmoticonAni} 2s forwards 1;
    }
  }
  .cheer-for-team-contents-wrap {
    width: 100%;
    height: 44px;
    background: ${theme.color.themeTxt};
    position: relative;
    border-radius: 6px 0 6px 6px;
    overflow: hidden;
    padding: 0 10px;
    .sports-ico {
      position: absolute;
      bottom: -14px;
      right: -3px;
      width: 50px;
      height: 50px;
      opacity: .06;
    }
    .match-state {
      position: absolute;
      left: 0;
      width: 3.5px;
      height: 100%;
      &.live {
        background: ${theme.color.modalred};
      }
      &.not-started {
        background: ${theme.color.tabBg};
      }
      &.closed {
        background: ${theme.color.disableTxt2};
      }
    }
    .match-info-wrap {
      width: 100%;
      height: 100%;
      padding: 4px 0;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .team-info {
        width: 100%;
        display: flex;
        justify-content: space-between;
        position: relative;
        .team-emblem {
          display: block;
          width: 14px;
          height: 14px;
          img {
            width: auto;
            height: 100%;
            transform: translateY(-1px);
          }
        }
        .home-team-name, .away-team-name {
          color: ${theme.color.modalTxt};
          font-size: ${theme.font.medium};
          font-weight: ${theme.fontW.medium}; 
          margin: 0 auto 0 1px;
        }
        .home-team-score, .away-team-score {
          color: ${theme.color.modalTxt};
          font-size: ${theme.font.medium};
          font-weight: ${theme.fontW.medium};
          &.win {
            color: ${theme.color.modalred};
            font-weight: ${theme.fontW.bold};
          }
          .match-state {
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            top: -2px;
            right: 0;
            width: auto;
            height: 3px;
            opacity: .35;
            .circle {
              display: block;
              width: 3px;
              height: 3px;
              border-radius: 50%;
              background: ${theme.color.modalTxt};
              margin-left: 2px;
            }
          }
        }
      }
    }
  }
  &.dark {
    .match-status-name {
      &.live {
       .match-status-name-txt {
         background: #AF1C39E6;
       }
      }
      &.closed {
        .match-status-name-txt {
          background: #ACACACE6;
        }
      }
    }
    .cheer-for-team-contents-wrap {
      background: linear-gradient(135deg, #DFE2EC, #BEC3CC);
    }
  }
  &.detail-bet-editor {
    min-width: 195px;
    max-width: 230px;
  }
`

export const UploadImgStyle = (theme: Theme) =>  css`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  background: ${theme.color.TP};
  img {
    width: auto;
    height: auto;
    max-width: 100vw;
    max-height: 100vh;
  }
  // 텍스트가 있는 이미지팝업 스타일 (스포츠 정보_
  &.is-txt {
    flex-wrap: wrap;
    img {
      max-height: calc(100vh - 210px);
    }
    .txt {
      margin: 10px 0 16px 0;
      width: 100%;
      font-size: ${theme.font.large};
      color: ${theme.color.themeTxt};
      max-height: initial;
      line-height: 100%;
    }
    &.pc {
      .txt {
        margin-top: 22px;
        font-size: ${theme.font.largeNum};
      }
    }
  }
`

export const ProfileMenu = styled.ul`
  .quick-menu-list {
    border-top: 1px solid ${props => props.theme.color.modalBg};
  }
  .chat-quick-btn {
    display: flex;
    align-items: center;
    margin-top: 10px;
    padding: 0 13px;
    width: 100%;
    height: 30px;
    background: ${props => props.theme.color.modalBg};
    color: ${props => props.theme.color.modalTxt};
    font-weight: ${props => props.theme.fontW.medium};
    border-radius: 7px;
    svg {
      width: 16px;
      height: auto;
      margin-right: 5px;
    }
    &.chat-reply {
      svg {
        width: 19px;
        margin-left: -2px;
      }
    }
    &.chat-favorite {
      svg {
        width: 20px;
        margin-left: -2px;
        margin-right: 3px;
        path {
          &.fill {
            fill: ${props => props.theme.color.modalSubBg};
          }
          &.line {
            fill: transparent;
          }
        }
      }
      &.active {
        svg path {
          &.fill {
            fill: ${props => props.theme.color.modalyellow};
          }
        }
      }
    }
    &.disabled {
      svg {
        width: 12px;
        margin-right: 7px;
      }
    }
  }
  .user-info {
    width: 100%;
    padding-bottom: 10px;
    text-align: center;
    background: none;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .profile-img-wrap {
      ${ProfileImgWrapStyle};
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 5px;
    }
  }
`
export const BettingListStyle = (theme: Theme) => css`
  z-index: 0;
  width: 195px;
  height: 77px;
  margin-bottom: 3px;
  padding: 10px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 1px 1px 6px rgba(0, 0, 0, .16);
  .betting-list-bg {
    position:absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    height: 100%;
  }
  .state {
    position: absolute;
    top: 10px;
    left: 10px;
    width: auto;
    height: 22px;
    .hit-state-img {
      width: auto;
      height: inherit;
      border-radius: 11px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, .07);
    }
  }
  .betting-list-info {
    position: relative;
    flex: 1;
    display: flex;
    flex-flow: column;
    align-items: flex-end;
    justify-content: center;
    padding: 2px 6px 0;
    line-height: 2.4rem;
    &--item {
      position: relative;
      &--txt {
        opacity: .6;
        margin-left: 5px;
        color: ${theme.color.modalTxt};
        font-weight: ${theme.fontW.medium};
      }
      &--num {
        color: ${theme.color.modalTxt};
        font-size: ${theme.font.xxlarge};
        text-shadow: 1px 1px 1px rgba(0,0,0,.15);
      }
      &.bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        div:not(.sports-ico-wrap) {
          display: inline-block;
        }
        .sports-ico-wrap {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transform: translateY(-1px);
          img {
            width: 14px;
            height: auto;
          }
          &.pc {
            margin-left: -6px;
            img {
              width: 12px;
            }
          }
        }
      }
    }
  }
  .open-betting-list {
    position:relative;
    display: block;
    margin-top: 4px;
    margin-bottom: -15px;
    text-align: right;
    font-size: ${theme.font.small};
    font-weight: ${theme.fontW.medium};
    svg {
      width: 10px;
      height: auto;
      margin-left: 4px;
      transform: rotate(-90deg) translateX(-1px);
      path {
        &#bg {
          fill: ${theme.color.themeTxt};
        }
        &#arrow {
          fill:${theme.color.mainBg};
        }
      }
    }
  }
  // MO버전 공유된 베팅내역
  &.betting-list {
    width: 100%;
    .betting-list-bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  // pc버전 공유된 베팅내역
  &.pc-betting-list {
    width: 148px;
    height: auto;
    .state {
      left: 7px;
    }
    .betting-list-info {
      &--item {
        padding: 0 2px;
        &--num {
          font-size: ${theme.font.large};
        }
        &--txt {
          font-size: ${theme.font.large};
        }
      }
    }
  }
  // 상세BET_응원글탭_응원글입력창 스타일
  &.detail-bet-betting-list {
    width: calc(100vw - 212px);
    min-width: 186px;
    max-width: 230px;
    .betting-list-bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    &.pc {
      width: 230px;
    }
    // 상세BET_응원글탭_리스트 스타일
    &.detail-bet-list {
      min-width: 195px;
    }
  }
`
export const ChatQuickSpotsMenuBtnStyle = (theme:Theme) => css`
  position: absolute;
  top: 4px;
  right: 14px;
  width: 50px;
  height: 42px;
  color: transparent;
  background: none;
  &::before {
    content: '';
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 19px;
    height: 19px;
    background: ${theme.color.modalSubBg};
    border-radius: 50%;
    transition: all .3s;
  }
  .ant-popover.betting-history-quick-menu {
    width: 137px;
  }
  .spots {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: ${theme.color.mainBg};
    &::before, &::after {
      content:'';
      display: block;
      position:absolute;
      top: 0;
      left: 0;
      width: 3px;
      height: 3px;
      border-radius: 50%;
      background: ${theme.color.mainBg};
    }
    &::before {
      top: -5px;
    }
    &::after {
      top: 5px;
    }
  }
  &.ant-popover-open {
    &::before {
      display: block;
    }
  }
  &.pc {
    right: 4px;
  }
  &.is-popular-searches {
    top: calc(4px + 48px);
  }
`
export const ChatLoginBtn = css`
  position: absolute;
  left: 0;
  width: 100%;
  border-radius: 0;
  &.tab-btn {
    top: 0;
    height: 43px;
  }
  &.input-btn {
    bottom: 0;
    height: 69px;
    &.pc-input-btn {
      height: 109px;
    }
  }
  &.chat-profile {
    left: 13px;
    width: 42px;
    height: 48px;
  }
`
export const PickNoticePopupWrap = styled.div`
  z-index: 1;
  // 실시같 채팅창 플로팅버튼 추가로 인해 기존 스타일 주석처리
  //position: absolute;
  //top: 56px;
  //right: 18px;
  width: auto;
  border-radius: 50px;
  background: ${props => props.theme.color.mainColor};
  box-shadow: 2px 4px 10px rgba(22, 26, 35, .3);
  .pick-notice-header {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    padding: 3px;
    background: ${props => props.theme.color.mainColor};
    border-radius: 50px;
    .pick-profile {
      width: 36px;
      min-width: 36px;
      height: 36px;
      margin: 0;
      border-radius: 50%;
      overflow: hidden;
      background: ${props => props.theme.color.yellow};
      img {
        width: inherit;
        height: auto;
        image-rendering: -webkit-optimize-contrast;
      }
    }
    .pick-notice {
      display: none;
      justify-content: space-between;
      align-items: center;
      width: calc(100% - 45px);
      .txt-box {
        display: flex;
        flex-flow: column;
        flex: 1;
        width: calc(100% - 30px);
        text-align: left;
        .author {
          line-height: 1.2rem;
          color: ${props => props.theme.color.disableTxt2};
          font-size: ${props => props.theme.font.small};
        }
        .txt {
          ${TxtLimit};
          line-height: 1.8rem;
        }
      }
      .btn-bg {
        position: relative;
        width: 27px;
        min-width: 27px;
        height: 27px;
        border-radius: 50%;
        background: ${props => props.theme.color.disableBg};
      }
      .cls-ico {
        position:absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%) rotate(45deg);
        width: 14px;
        height: 14px;
        &::before, &::after {
          content: '';
          display: block;
          position:absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border-radius: 10px;
          background: ${props => props.theme.color.modalBg};
        }
        &::before {
          width: 100%;
          height: 2px;
        }
        &::after {
          width: 2px;
          height: 100%;
        }
      }
    }
  } /* pick-notice-header */
  .pick-notice-body {
    display: none;
    padding-bottom: 6px;
    background: ${props => props.theme.color.themeTxt};
    border-radius: 0 0 14px 14px;
    .pick-list {
      &--item {
        .pick-btn {
          position: relative;
          display: flex;
          justify-content: space-around;
          align-items: center;
          width: 100%;
          height: 60px;
          padding: 0 16px;
          border-radius: 0;
          .line {
            opacity: .2;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: calc(100% - 18px);
            height: 1px;
            border-bottom: 1px solid ${props => props.theme.color.disableTxt2};
          }
        }
        .chat-pick-ico {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 27px;
          height: 27px;
          background: ${props => props.theme.color.primaryBg};
          border-radius: 9px;
          img {
            width: 21px;
            height: 21px;
          }
        }
        &:last-of-type {
          .line {
            display: none;
          }
        }
      }
    }
    .more-btn {
      width: 100%;
      padding: 16px 0;
      color: ${props => props.theme.color.modalTxt};
      overflow: hidden;
      svg {
        width: 10px;
        transform: rotate(-90deg) translate(1px, 1px);
        path {
          fill: ${props => props.theme.color.modalTxt};
        }
      }
    }
    &.hover-effect {
      border-top: 1px solid ${props => props.theme.color.modalBg};
      .pick-list {
        &--item {
          &:hover {
            .pick-btn {
              background: ${props => props.theme.color.modalBg};
            }
            .vs {
              color: ${props => props.theme.color.themeTxt};
            }
          }
        }
      }
    }
  } /* pick-notice-body */
  .new-badge {
    z-index: 1;
    position: absolute;
    top: 0;
    right: -2px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .3);
  }
  // 열린 상태
  &.active {
    position: fixed;
    width: calc(100% - 28px);
    top: 155px;
    left: 50%;
    z-index: 2;
    transform: translateX(-50%);
    .pick-notice-header {
      width: 100%;
      padding: 10px 14px;
      border-radius: 14px 14px 0 0;
      .pick-notice {
        display: flex;
      }
    }
    .pick-notice-body {
      display: block;
    }
    .new-badge {
      display: none;
    }
  }
  &.no-pick {
    .pick-notice-header {
      border-radius: 14px;
    }
    .pick-notice-body > div {
      max-height: 200px;
      .empty-wrap {
        transform: translate(-50%, -50%);
      }
    }
  }
  &.pc-pick-notice-wrap {
    position: relative;
    top: initial;
    right: initial;
    width: 100%;
    //margin-top: -18px;
    box-shadow: none;
  }
`
export const ChatFloatingBtnStyle = css`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  box-shadow: 2px 4px 8px #00000025;
  .btn-img {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 50px;
    width: inherit;
    object-fit: cover;
  }
`
export const ChatFavoriteMatchBtnStyle = css`
  position: absolute;
  top: 0;
  right: 68px;
  margin: 8px 0;
  border-radius: 10px;
  box-shadow: 2px 2px 6px #00000029;
  &.pc {
    right: 55px;
  }
  &.is-popular-searches {
    &:not(.pc) {
      top: 49px;
    }
  }
`
export const ChatTodayUserPickListItemStyle = (theme:Theme) => css`
  border-radius: 14px;
  overflow: hidden;
  background: linear-gradient(to bottom, #212732, #2C3340);
  .top-txt {
    position: relative;
    min-height: 70px;
    img {
      width: auto;
      max-width: 100%;
      height: auto;
      max-height: 110px;
    }
    .txt {
      position: absolute;
      top: 64%;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      color: #9D5619;
      .nickname {
        color: ${theme.color.modalTxt};
      }
    }
  }
  .user-pick-detail-chat {
    margin: 0 27px 21px;
    padding: 0;
    .popup-item {
      .pick-contents {
        .select-box {
          padding: 14px 0;
        }
      }
    }
  }
  &.pc {
    .top-txt {
      img {
        width: 100%;
        height: auto;
      }
      .txt {
        top: 61%;
        font-size: ${theme.font.small};
        .nickname {
          font-size: ${theme.font.small};
        }
      }
    }
    .user-pick-detail-chat {
      margin: 0 12px 14px;
      .user-pick-profile {
        .match-info.popup {
          padding: 0 13px;
        }
      }
    }
  }
`
